export function checkValidity(value, rules) {
    let isValid = true;
    if (!rules) {
        return true;
    }

    if (rules.required) {
        isValid = value.trim() !== "" && isValid;
    }

    if (rules.minLength) {
        isValid = value.length >= rules.minLength && isValid;
    }

    if (rules.maxLength) {
        isValid = value.length <= rules.maxLength && isValid;
    }

    if (rules.isEmail) {
        isValid = value.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g) !== null && isValid;
    }

    if (rules.isNumeric) {
        const pattern = /^\d+$/;
        isValid = pattern.test(value) && isValid;
    }

    if (rules.isURL) {
        const pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
            '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
        isValid = !!pattern.test(value) && isValid;
    }
    //console.log("Utils", isValid)
    return isValid;
}

export const updateObject = (oldObject, updateProperties) => {
    return {
        ...oldObject,
        ...updateProperties
    };
};

export const postObjectFromResponse = (data, key, id = 1) => {
    const url = data.url
    const domain = url.replace('http://', '').replace('https://', '').split(/[/?#]/)[0]
    return {
        ...data,
        postId: key,
        id: id,
        domain: domain
    };
}

export const listOfPostFromResponse = (response) => {
    const data = []
    let id = 1
    for (let key in response.data) {
        const post = postObjectFromResponse(response.data[key], key, id++)
        data.push(post)
    }
    return data;
}

export const listOfCommentsFromResponse = (response) => {
    const data = []
    let id = 1
    for (let key in response.data) {
        const comment = {
            ...response.data[key],
            commentId: key,
            id:id++
        }
        data.push(comment)
    }
    return data;
}

export const getDifferenceBetweenDates = (startDate, endDate) => {
    const diff = endDate.getTime() - startDate.getTime();
    const days = diff/(24*60*60*1000)
    if(days > 1){
        return days.toFixed(0) + " days ago"
    }
    const hours = diff/(60*60*1000)
    if(hours > 1){
        return hours.toFixed(0) + " hours ago"
    }
    return (diff / 60000).toFixed(0) + " minutes ago";
}

export const getRandomId = () => {
    return Math.random().toString(32).slice(-6)
}